
































import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import {
  ApiSearchColumn,
  ColumnType,
} from "@/components/apiSearch/models/ApiSearch";
import Vue from "vue";
import store from "../services/store";
import AccComplaint from "../models/AccComplaint";
import { t } from "@/plugins/i18n";

export default Vue.extend({
  async beforeMount() {
    this.loading = true;
    await store.loadStatuses();
    this.loading = false;
  },

  methods: {
    getGeniLink(geni: string): string {
      return `general-incoming-invoice/flow/edit/${geni}/2`;
    },

    getStatusName(status: number): string {
      return store.statuses.find((x) => x.id == status)?.name ?? "";
    },

    getType(item: AccComplaint): string {
      return item.reQuantity > 0 || item.wasteQuantity > 0
        ? t("AccComplaints_Mennyisegi")
        : t("Ertek");
    },
  },

  components: {
    ApiSearchPage,
  },

  data: () => {
    return {
      loading: false,
    };
  },

  computed: {
    url() {
      return "acc-complaints/search";
    },

    columns: (): ApiSearchColumn[] => [
      {
        title: t("Partner"),
        field: "partner",
      },
      {
        title: t("Cikk"),
        field: "parts",
      },
      {
        title: t("AccComplaints_ReklamacioFej"),
        field: "complaintHeadID",
      },
      {
        title: t("ReklamacioTetel"),
        field: "complainedItemID"
      },
      {
        title: t("TerhelesiErtesito"),
        field: "complaintID",
      },
      {
        title: t("AccComplaints_ElozmenyTerhelesiErtesito"),
        cell: "prevComplaint",
        field: "prevDebitNotiId",
      },
      {
        title: t("Tipus"),
        field: "complaintID",
        filterable: false,
        sortable: false,
        cell: "type",
      },
      {
        title: t("Statusz"),
        field: "status",
        cell: "status",
        multiselect: true,
        multiselectField: "selectedStatuses",
        multiselectOptions: store.statuses.map((x) => ({
          text: x.name,
          value: x.id,
        })),
      },
      {
        title: t("Megrendeles"),
        field: "order",
      },
      {
        title: t("Szallitolevel"),
        field: "storeIn",
      },
      {
        title: t("Keszlet"),
        field: "stockID",
      },
      {
        title: "GENI",
        field: "geni",
        cell: "geni",
      },
      {
        title: t("HelyesbitoSzamla"),
        field: "isFixingInv",
        cell: "isFixingInv",
        headerClass: "text-center",
        fieldClass: "text-center"
      },
      {
        title: t("AccComplaints_VisszaruzottMennyiseg"),
        field: "reQuantity",
      },
      {
        title: t("AccComplaints_SelejtezettMennyiseg"),
        field: "wasteQuantity",
      },
      {
        title: t("AccComplaints_ErtekhelyesbitettMennyiseg"),
        field: "fixedQuantity",
      },
      {
        title: t("HelyesbitesOsszege"),
        field: "fixedPrice",
        type: ColumnType.Money,
      },
      {
        title: t("AccComplaints_RendezettOsszeg"),
        field: "settledAmount",
        type: ColumnType.Money,
      },
    ],
  },
});
